import {formatPrice} from '../hooks/generalHooks';
import SERVER from '../hooks/useServer';
import { PiShoppingCartSimple } from "react-icons/pi";
import { useTranslation } from 'react-i18next';

const ProductCard = ({ product, onClick, onAddToCart, highlightTitle }) => {
    const { i18n } = useTranslation();
    const caracteristiques = Object.values(product?.main_caracteristiques || {}).slice(0, 3);

    const handleAddToCart = (e) => {
        e.stopPropagation();
        onAddToCart(product);
    };

    return (
        <div 
            className="rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 flex flex-col"
            onClick={onClick}
        >
            {/* Image Container with rounded background */}
            <div className="relative bg-[#ebecea]/70 rounded-[24px] lg:rounded-[36px] m-2 lg:m-4 p-3 lg:p-6 flex items-center justify-center" style={{ aspectRatio: '5/6' }}>
                <img 
                    src={`${SERVER}/${product?.banner_image}`} 
                    alt={product?.title}
                    className="w-full h-full object-contain"
                />
                
                {/* Badges */}
                {product?.promotion > 0 ? (
                    <span className="absolute top-1 right-1 lg:top-2 lg:right-2 bg-red-500 text-white text-[10px] lg:text-xs font-semibold px-2 lg:px-3 py-0.5 lg:py-1 rounded-full">
                        -{formatPrice(product.promotion, 0)}%
                    </span>
                ) : product?.nouveaute && (
                    <span className="absolute top-1 right-1 lg:top-2 lg:right-2 bg-primary text-white text-[10px] lg:text-xs font-semibold px-2 lg:px-3 py-0.5 lg:py-1 rounded-full">
                        NEW
                    </span>
                )}
            </div>

            {/* Content */}
            <div className="px-2 pb-2 lg:px-4 lg:pb-4 flex flex-col flex-grow">
                {/* Product Title */}
                <h3 className="text-gray-800 text-xs lg:text-base font-normal mb-0 line-clamp-2 min-h-[2.5rem] lg:min-h-[3rem]">
                    {product?.title}
                </h3>

                {/* Characteristics - only show if not highlight */}
                {/* {!highlightTitle && (
                    <div className="text-xs text-gray-600 space-y-1 mb-4">
                        {caracteristiques.map((carac, index) => (
                            <div key={index}>
                                {(i18n.language === 'en' && carac.title_en) ? carac.title_en : carac.title}: <span className="font-semibold">{carac.value} {(i18n.language === 'en' && carac.unity_en) ? carac.unity_en : carac.unity}</span>
                            </div>
                        ))}
                    </div>
                )} */}

                {/* Pricing and Cart Button */}
                <div className="flex items-center justify-between mt-0 pt-1 lg:pt-2">
                    <div className="flex flex-col">
                        {product?.promotion > 0 ? (
                            <>
                                <span className="text-primary text-base lg:text-2xl font-bold">
                                    € {formatPrice(product.price * (1 - product.promotion / 100))}
                                </span>
                                <span className="text-gray-400 text-[10px] lg:text-sm line-through">
                                    € {formatPrice(product.price)}
                                </span>
                            </>
                        ) : (
                            <span className="text-primary text-base lg:text-2xl font-bold">
                                € {formatPrice(product?.price)}
                            </span>
                        )}
                    </div>

                    <button 
                        onClick={handleAddToCart}
                        className="bg-primary text-white rounded-full w-8 h-8 lg:w-10 lg:h-10 flex items-center justify-center hover:bg-blue-700 transition-colors shadow-lg flex-shrink-0"
                    >
                        <PiShoppingCartSimple size={20} className="lg:hidden" />
                        <PiShoppingCartSimple size={24} className="hidden lg:block" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ProductCard;
